import createFormModule from '../../utils/createFormModule'
import {
  SET_SALUTATION,
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_JOB_TITLE,
  SET_VISIBILITY,
  SET_INTERESTS,
  VISIBILITY_IS_PRIVATE,
  VISIBILITY_IS_PUBLIC
} from './types'

const formModule = createFormModule({ resourcePath: '/users/:userId', resourceName: 'user' })

export const state = {
  ...formModule.state,
  form: {
    salutation: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    interests: [],
    visibility: VISIBILITY_IS_PRIVATE
  }
}

export const mutations = {
  ...formModule.mutations,
  [SET_SALUTATION] (state, value) {
    state.form.salutation = value
  },
  [SET_FIRST_NAME] (state, value) {
    state.form.firstName = value
  },
  [SET_LAST_NAME] (state, value) {
    state.form.lastName = value
  },
  [SET_JOB_TITLE] (state, value) {
    state.form.jobTitle = value
  },
  [SET_VISIBILITY] (state, value) {
    state.form.visibility = value
  },
  [SET_INTERESTS] (state, value) {
    state.form.interests = value
  }
}

export const actions = {
  ...formModule.actions,
  setSalutation ({ commit }, value) {
    commit(SET_SALUTATION, value)
  },
  setFirstName ({ commit }, value) {
    commit(SET_FIRST_NAME, value)
  },
  setLastName ({ commit }, value) {
    commit(SET_LAST_NAME, value)
  },
  setJobTitle ({ commit }, value) {
    commit(SET_JOB_TITLE, value)
  },
  setVisibility ({ commit }, value) {
    commit(SET_VISIBILITY, value)
  },
  setInterests ({ commit }, value) {
    const interests = value.map(t => {
      return t.id
        ? { label: t.name, value: t.name }
        : { label: t.label, value: t.value }
    })
    commit(SET_INTERESTS, interests)
  },
  setIsPublic ({ commit }, value) {
    const visibility = value ? VISIBILITY_IS_PUBLIC : VISIBILITY_IS_PRIVATE
    commit(SET_VISIBILITY, visibility)
  }
}

export const getters = {
  ...formModule.getters,
  salutationOptions () {
    return [
      { label: 'Frau', value: 'Frau' },
      { label: 'Herr', value: 'Herr' }
    ]
  },
  isPublic (state) {
    return state.form.visibility === VISIBILITY_IS_PUBLIC
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/accountForm.js